import { HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError, UnaryFunction } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { MixpanelService } from '../services/mixpanel.service';
import { ServerErrorUtils } from '../utils/server-error-utils';

export function mixpanelErrorProps(error: unknown): Record<string, unknown> {
  const http = error instanceof HttpErrorResponse ? error : null;
  const validationMessages = http ? ServerErrorUtils.getValidationMessages(http) : null;

  return {
    http_status: http?.status ?? null,
    error_code: http?.error?.error?.code ?? null,
    error_messages: validationMessages ?? null,
    error_message:
      validationMessages?.[0] ??
      http?.error?.message ??
      (error instanceof Error ? error.message : 'unknown'),
  };
}

export function trackMixpanelFailure(
  mixpanel: MixpanelService,
  failureEvent: string,
  contextProps: Record<string, unknown>,
  error: unknown,
  extraProps?: Record<string, unknown>
): void {
  mixpanel.track(failureEvent, {
    ...contextProps,
    ...mixpanelErrorProps(error),
    ...extraProps,
  });
}

export function withMixpanelOutcome<T>(
  mixpanel: MixpanelService,
  config: {
    successEvent: string;
    failureEvent: string;
    successProps: (result: T) => Record<string, unknown>;
    failureProps?: () => Record<string, unknown>;
  }
): UnaryFunction<Observable<T>, Observable<T>> {
  return (source) =>
    source.pipe(
      tap((result) => mixpanel.track(config.successEvent, config.successProps(result))),
      catchError((error) => {
        trackMixpanelFailure(mixpanel, config.failureEvent, config.failureProps?.() ?? {}, error, {
          error_source: 'http',
        });
        return throwError(error);
      })
    );
}
